import React from "react";


const ApplyForm = () => {
  return (
    <div className="apply-form-container">
      <h2 className="form-title">Apply For This Position</h2>
      <form>
        <div className="form-group">
          <label>Full Name<span className="required">*</span></label>
          <input type="text" name="fullName" required />
        </div>

        <div className="form-group">
          <label>Enter Your Email<span className="required">*</span></label>
          <input type="email" name="email" required />
        </div>

        <div className="form-group">
          <label>Enter Your Phone Number<span className="required">*</span></label>
          <input type="tel" name="phone" required />
        </div>

        <div className="form-group">
          <label>Upload CV/Resume<span className="required">*</span></label>
          <input type="file" name="resume" required />
        </div>

        <div className="check-box">
          <input type="checkbox" id="text" name="text" value="text" required />
          <label>By using this form you agree with the storage and handling of your data by this website.*</label>

        </div>

        <button type="submit" className="submit-btn">Submit</button>
      </form>
    </div>
  );
};

export default ApplyForm;
